export const FETCH_JOURNEYS = 'FETCH_JOURNEYS';
export const FETCH_JOURNEYS_SUCCESS = 'FETCH_JOURNEYS_SUCCESS';
export const FETCH_JOURNEYS_FAILED = 'FETCH_JOURNEYS_FAILED';

export const CREATE_RANDOM_TODO = 'CREATE_RANDOM_TODO';

export const GENERATE_MAGIC_WALL = 'GENERATE_MAGIC_WALL';
export const GENERATE_MAGIC_WALL_SUCCESS = 'GENERATE_MAGIC_WALL_SUCCESS';
export const GENERATE_MAGIC_WALL_FAILED = 'GENERATE_MAGIC_WALL_FAILED';
